import { createTransform } from "redux-persist";

const SetTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  inboundState => {
    return {
      // ...inboundState,
      PitchItForm: inboundState.PitchItForm,
      projectSowForm: inboundState.projectSowForm
    };
  },

  // transform state being rehydrated
  outboundState => {
    return {
      // ...outboundState,
      PitchItForm: outboundState.PitchItForm,
      projectSowForm: outboundState.projectSowForm
    };
  },

  // define which reducers this transform gets called for.
  { whitelist: ["form"] }
);

export default SetTransform;



// WEBPACK FOOTER //
// ./src/transforms.js